import { AccountClockOutlineIcon } from './AccountClockOutlineIcon';

/**
 * author: Coffeemate
 * id AA800DB2-3369-412C-B881-0F99863D13F7
 * name account-clock-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-clock-outline.svg
 * tags
 * - Account / User 
 * - Date / Time 
 */
export const UserClockOutlineIcon = AccountClockOutlineIcon;
export default UserClockOutlineIcon